class TrustBadgeScroller extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      grid: '.trust-badges__grid',
    };

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.grid = this.querySelector(this.selectors.grid);

    if (!this.grid) {
      return;
    }

    this.grid.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.updateShadows();
  }

  disconnectedCallback() {
    if (this.grid) {
      this.grid.removeEventListener('scroll', this.onScroll);
    }

    window.removeEventListener('resize', this.onResize);
  }

  onScroll() {
    this.updateShadows();
  }

  onResize() {
    this.updateShadows();
  }

  updateShadows() {
    if (!this.grid) {
      return;
    }

    const mobileBreakpoint = 989;

    if (window.innerWidth > mobileBreakpoint) {
      this.classList.remove('is-at-start', 'is-at-end', 'is-not-scrollable');
      return;
    }

    const maxScrollLeft = this.grid.scrollWidth - this.grid.clientWidth;

    if (maxScrollLeft <= 1) {
      this.classList.add('is-not-scrollable');
      this.classList.remove('is-at-start', 'is-at-end');
      return;
    }

    const threshold = 2;
    const scrollLeft = this.grid.scrollLeft;
    const atStart = scrollLeft <= threshold;
    const atEnd = scrollLeft >= maxScrollLeft - threshold;

    this.classList.remove('is-not-scrollable');
    this.classList.toggle('is-at-start', atStart);
    this.classList.toggle('is-at-end', atEnd);
  }
}

if (!customElements.get('trust-badge-scroller')) {
  customElements.define('trust-badge-scroller', TrustBadgeScroller);
}
